var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLogOutLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70801 3C3.70801 2.65482 3.98783 2.375 4.33301 2.375H11.6664C12.0115 2.375 12.2914 2.65482 12.2914 3V4C12.2914 4.20711 12.4592 4.375 12.6664 4.375C12.8735 4.375 13.0414 4.20711 13.0414 4V3C13.0414 2.24061 12.4257 1.625 11.6664 1.625H4.33301C3.57362 1.625 2.95801 2.24061 2.95801 3V13C2.95801 13.7594 3.57362 14.375 4.33301 14.375H11.6664C12.4257 14.375 13.0414 13.7594 13.0414 13V12C13.0414 11.7929 12.8735 11.625 12.6664 11.625C12.4592 11.625 12.2914 11.7929 12.2914 12V13C12.2914 13.3452 12.0115 13.625 11.6664 13.625H4.33301C3.98783 13.625 3.70801 13.3452 3.70801 13V3ZM12.9312 8.26517C13.0015 8.19484 13.041 8.09946 13.041 8C13.041 7.90055 13.0015 7.80516 12.9312 7.73484L10.9312 5.73484C10.7847 5.58839 10.5473 5.58839 10.4008 5.73484C10.2544 5.88128 10.2544 6.11872 10.4008 6.26516L11.7607 7.625H7.99934C7.79224 7.625 7.62434 7.7929 7.62434 8C7.62434 8.20711 7.79224 8.375 7.99934 8.375H11.7607L10.4008 9.73484C10.2544 9.88129 10.2544 10.1187 10.4008 10.2652C10.5473 10.4116 10.7847 10.4116 10.9312 10.2652L12.9312 8.26517Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLogOutLined);
export default __webpack_public_path__ + "static/media/ic_log_out_lined.20c42f7fa7bda1655ec91491ad96bf58.svg";
export { ForwardRef as ReactComponent };